<template>
  <svg
    :width="dimensions.width"
    :height="dimensions.height"
    :viewBox="`0 0 ${dimensions.width} ${dimensions.height}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Layer_1" clip-path="url(#clip0_605_8045)">
      <path id="Vector" d="M3.89062 1.91211H40.5546" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_2" d="M14.0525 18.207C14.0525 18.207 13.9711 19.1847 13.8285 19.6329C13.6859 20.1013 13.4618 20.5495 13.1767 20.9568C12.8508 21.4253 12.4434 21.8531 11.9749 22.2197C10.8954 23.0548 9.51027 23.5437 7.96223 23.5437C7.26969 23.5437 6.61788 23.4418 6.00682 23.2585C4.62173 22.8511 3.46071 22.016 2.72742 20.9568C2.17746 20.1421 1.85156 18.207 1.85156 18.207H14.0729H14.0525Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_3" d="M17.1296 32.4648H27.314C29.0046 32.4648 30.3693 33.8296 30.3693 35.5202V38.5755H14.0742V35.5202C14.0742 33.8296 15.4389 32.4648 17.1296 32.4648Z" stroke="#435363" stroke-width="2" stroke-linejoin="round"/>
      <path id="Vector_4" d="M22.2031 22.281V1.91211" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_5" d="M22.2031 32.4664V28.3926" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_6" d="M7.94409 3.94922L14.0548 18.2074H1.89453L7.94409 3.94922Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_7" d="M44.6072 18.207C44.6072 18.207 44.5257 19.1847 44.3832 19.6329C44.2406 20.1013 44.0165 20.5495 43.7314 20.9568C43.4054 21.4253 42.9981 21.8531 42.5296 22.2197C41.45 23.0548 40.065 23.5437 38.5169 23.5437C37.8244 23.5437 37.1726 23.4418 36.5615 23.2585C35.1764 22.8511 34.0154 22.016 33.2821 20.9568C32.7322 20.1421 32.4062 18.207 32.4062 18.207H44.6276H44.6072Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
      <path id="Vector_8" d="M38.4949 3.94922L44.6055 18.2074H32.4453L38.4949 3.94922Z" stroke="#435363" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_605_8045">
        <rect width="45.83" height="39.7193" fill="white" transform="translate(0.304688 0.384766)"/>
      </clipPath>
    </defs>
  </svg>

</template>
<script>
export default {
  props: {
    width: {
      required: false,
      type: [Number, String],
      default: 47,
    },
    height: {
      required: false,
      type: [Number, String],
      default: 41,
    },
    useCustomDimensions: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultWidth: 47,
      defaultHeight: 41,
    };
  },
  computed: {
    dimensions() {
      return {
        width: this.useCustomDimensions ? this.width : this.defaultWidth,
        height: this.useCustomDimensions ? this.height : this.defaultHeight,
      };
    },
  },
};
</script>
